import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import safetyChassisKeys from '../keys';
import getSpecificChassisData from '../../../../service/Safety/Chassis/Get/getSpecificChassisData';
import SAFETY_CHASSIS_MODAL_DEFAULT_VALUE from '../../../../constant/Safety/Chassis/Modal/defaultValue';
import { ALERT_MODAL_STATUS } from '../../../../constant/Common/Modal/Alert/status';

const useGetSpecificChassisData = ({ seq, isModalOpen, ...props }) => {
  const { setAlertOpen, setAlertModalStatus } = props;

  const [specificData, setSpecificData] = useState({
    ...SAFETY_CHASSIS_MODAL_DEFAULT_VALUE,
  });

  const query = useQuery({
    queryKey: safetyChassisKeys?.specificData({ seq }),
    queryFn: () => getSpecificChassisData({ seq }),
    refetchOnWindowFocus: false,
    enabled: !!seq && !!isModalOpen,
  });

  useEffect(() => {
    if (query?.data) {
      setSpecificData(prev => query?.data?.data);
    } else {
      setSpecificData(prev => {
        return { ...SAFETY_CHASSIS_MODAL_DEFAULT_VALUE };
      });
    }
  }, [query?.data]);

  useEffect(() => {
    if (query?.isError) {
      setAlertModalStatus(prev => {
        return {
          status: ALERT_MODAL_STATUS.ERROR,
          message: query?.error?.message,
        };
      });
      setAlertOpen(prev => true);
    }
  }, [query?.isError]);

  return { specificData, ...query };
};

export default useGetSpecificChassisData;
